module.exports = __webpack_public_path__ + "img/arrow_mcpf9g.11c52eff.svg";